import { IdModal } from "../../modals/IdModal";
import { BuildingCategory } from "../../player-base/buildings/BuildingCategory";
import { createPathSelectTabInModal } from "./createPathSelectTabInModal";
export var pathSelectDecorationTabInBuildMenu = function (action, state$, deps) {
    return createPathSelectTabInModal(function () { return IdModal.BuildingList; }, function () { return BuildingCategory.Decorations; })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/pathSelectDecorationTabInBuildMenu.ts
// module id = 2371
// module chunks = 3